<div class="section-heading action-heading">

  <div>

    <span class="section-kicker">
      Protected portals
    </span>

    <h2>
      Crew & manager resources
    </h2>

    <p>
      Manage external links, protected PDF documents
      and upcoming resources shown inside the employee portals.
    </p>

  </div>

  <button
    type="button"
    class="primary-btn"
    (click)="openWhitelistEditor()"
  >
    ＋ Add resource
  </button>

</div>


<div
  *ngIf="whitelistItemsLoading"
  class="panel portal-resource-state"
>
  Loading portal resources...
</div>


<div
  *ngIf="!whitelistItemsLoading"
  class="entity-list"
>

  <article
    class="entity-card resource-admin-card"
    *ngFor="
      let item of whitelistItems;
      trackBy: trackById
    "
  >

    <div
      class="entity-marker resource-marker"
      [class.document-marker]="item.documentId"
      [class.placeholder-marker]="
        !item.documentId && !item.url
      "
    >
      @if (item.documentId) {
        PDF
      } @else if (item.url) {
        ↗
      } @else {
        •
      }
    </div>


    <div class="entity-main">

      <div class="entity-title-row">

        <div>

          <h3>
            {{ item.name }}
          </h3>

          <p>
            {{ item.category }}
          </p>

        </div>


        <div class="resource-admin-pills">

          <span
            class="role-pill"
            [class.manager-pill]="item.role === 'Manager'"
          >
            {{ item.role }}
          </span>

          <span
            class="active-pill"
            [class.inactive-pill]="!item.isActive"
          >
            {{ item.isActive ? 'Active' : 'Hidden' }}
          </span>

        </div>

      </div>


      <div class="entity-details">

        <span>

          <strong>
            Type
          </strong>

          @if (item.documentId) {
            PDF document
          } @else if (item.url) {
            External link
          } @else {
            Coming soon
          }

        </span>


        <span>

          <strong>
            Display order
          </strong>

          {{ item.displayOrder }}

        </span>


        <span *ngIf="item.url">

          <strong>
            URL
          </strong>

          <span class="resource-url">
            {{ item.url }}
          </span>

        </span>

      </div>

    </div>


    <div class="entity-actions">

      <button
        type="button"
        class="edit-btn"
        (click)="openWhitelistEditor(item)"
      >
        Edit
      </button>

      <button
        type="button"
        class="delete-btn"
        (click)="
          requestDelete(
            'whitelist',
            item.id,
            item.name
          )
        "
      >
        Delete
      </button>

    </div>

  </article>


  <div
    *ngIf="!whitelistItems.length"
    class="panel empty-state large"
  >

    <strong>
      No portal resources
    </strong>

    <p>
      Add the first Crew or Manager resource
      to begin building the protected portals.
    </p>

  </div>

</div>


<!-- RESOURCE EDITOR -->

<div
  *ngIf="whitelistEditorOpen"
  class="modal-backdrop"
>

  <section
    class="editor-modal wide"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <header class="modal-header">

      <div>

        <span class="section-kicker">
          Protected portal
        </span>

        <h2>
          {{
            whitelistDraft.id
              ? 'Edit resource'
              : 'Add resource'
          }}
        </h2>

      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Close"
        (click)="closeWhitelistEditor()"
      >
        ×
      </button>

    </header>


    <form (ngSubmit)="saveWhitelistItem()">

      <div class="form-grid">

        <div class="form-field">

          <label for="resource-name">
            Resource name
          </label>

          <input
            id="resource-name"
            name="resourceName"
            [(ngModel)]="whitelistDraft.name"
            placeholder="UKG"
            required
          />

        </div>


        <div class="form-field">

          <label for="resource-role">
            Portal
          </label>

          <select
            id="resource-role"
            name="resourceRole"
            [(ngModel)]="whitelistDraft.role"
            required
          >

            <option value="Crew">
              Crew
            </option>

            <option value="Manager">
              Manager
            </option>

          </select>

          <small>
            Manager pages already include Crew resources.
          </small>

        </div>


        <div class="form-field">

          <label for="resource-category">
            Category
          </label>

          <input
            id="resource-category"
            name="resourceCategory"
            [(ngModel)]="whitelistDraft.category"
            placeholder="Human Resources"
            required
          />

        </div>


        <div class="form-field">

          <label for="resource-order">
            Display order
          </label>

          <input
            id="resource-order"
            name="resourceOrder"
            type="number"
            min="0"
            [(ngModel)]="whitelistDraft.displayOrder"
          />

          <small>
            Lower numbers appear first
            within the category.
          </small>

        </div>


        <div class="form-field full-width">

          <label for="resource-url">
            External URL
          </label>

          <input
            id="resource-url"
            name="resourceUrl"
            type="url"
            [(ngModel)]="whitelistDraft.url"
            placeholder="https://..."
          />

          <small>
            Leave blank when using a PDF document
            or creating a Coming Soon placeholder.
          </small>

        </div>


        <div class="form-field full-width">

          <label>
            Resource visibility
          </label>

          <label class="checkbox-label">

            <input
              name="resourceActive"
              type="checkbox"
              [(ngModel)]="whitelistDraft.isActive"
            />

            Display this resource

          </label>

        </div>

      </div>


      <div class="upload-field document-upload">

        <div
          class="document-preview"
          [class.has-document]="
            whitelistDraft.documentId ||
            selectedWhitelistDocument
          "
        >

          <span class="document-preview-icon">
            ▤
          </span>

          <strong>
            PDF
          </strong>

        </div>


        <div class="document-upload-info">

          <strong>
            Protected document
          </strong>

          @if (selectedWhitelistDocument) {

            <p class="selected-document-name">
              {{ selectedWhitelistDocument.name }}
            </p>

          } @else if (whitelistDraft.documentId) {

            <p>
              A protected PDF is currently attached
              to this resource.
            </p>

          } @else {

            <p>
              Optional. Upload a PDF for forms,
              instructions or internal documents.
            </p>

          }


          <div class="upload-actions">

            <label class="secondary-btn file-btn">

              @if (
                whitelistDraft.documentId ||
                selectedWhitelistDocument
              ) {
                Replace PDF
              } @else {
                Choose PDF
              }

              <input
                type="file"
                accept=".pdf,application/pdf"
                (change)="
                  onWhitelistDocumentSelected(
                    $event
                  )
                "
              />

            </label>


            <button
              *ngIf="whitelistDraft.documentId"
              type="button"
              class="delete-btn"
              (click)="removeWhitelistDocument()"
            >
              Remove PDF
            </button>

          </div>

        </div>

      </div>


      <div
        class="resource-placeholder-note"
        *ngIf="
          !whitelistDraft.url &&
          !whitelistDraft.documentId &&
          !selectedWhitelistDocument
        "
      >

        <div class="placeholder-note-icon">
          •
        </div>

        <div>

          <strong>
            Coming Soon placeholder
          </strong>

          <p>
            This resource has no URL or PDF.
            It will remain visible in the portal as
            a disabled Coming Soon item.
          </p>

        </div>

      </div>


      <div class="form-actions modal-actions">

        <button
          type="button"
          class="text-btn"
          (click)="closeWhitelistEditor()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="primary-btn"
        >
          Save resource
        </button>

      </div>

    </form>

  </section>

</div>


<!-- DELETE CONFIRMATION -->

<div
  *ngIf="deleteRequest"
  class="modal-backdrop confirm-backdrop"
  (click)="cancelDelete()"
>

  <section
    class="confirm-modal"
    role="alertdialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="confirm-icon">
      !
    </div>

    <h2>
      Delete “{{ deleteRequest.label }}”?
    </h2>

    <p>
      This portal resource will be permanently removed.
      This action cannot be undone.
    </p>

    <div class="form-actions">

      <button
        type="button"
        class="secondary-btn"
        (click)="cancelDelete()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="danger-btn"
        (click)="confirmDelete()"
      >
        Delete permanently
      </button>

    </div>

  </section>

</div>